module.exports = __webpack_public_path__ + "79fcf270400edca30d7790872057d26c.svg";